import { render, staticRenderFns } from "./LicenseAdd.vue?vue&type=template&id=6930dcc2&"
import script from "./LicenseAdd.vue?vue&type=script&lang=js&"
export * from "./LicenseAdd.vue?vue&type=script&lang=js&"
import style0 from "./LicenseAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports